<template>
  <input
    ref="input"
    type="text"
    inputmode="decimal"
    :value="display"
    :placeholder="placeholder"
    :class="inputClass"
    :disabled="disabled"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script>
// Global summa inputi — yozilayotganda ming ajratkichi (probel) bilan formatlaydi,
// lekin v-model orqali toza Number qiymat qaytaradi.
import { formatSumma, buildSumma } from '../utils/formatSumma';

export default {
  name: 'SummaInput',
  props: {
    value: { type: [Number, String], default: 0 },
    placeholder: { type: String, default: '0' },
    precision: { type: Number, default: 2 },
    inputClass: { type: [String, Array, Object], default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      display: '',
      focused: false,
    };
  },
  watch: {
    value(v) {
      // Tashqaridan qiymat o'zgarsa (fokusda bo'lmasa) displayni yangilash
      if (!this.focused) this.display = this.toDisplay(v);
    },
  },
  mounted() {
    this.display = this.toDisplay(this.value);
  },
  methods: {
    toDisplay(v) {
      const num = Number(v) || 0;
      return num === 0 ? '' : formatSumma(num, this.precision);
    },
    onFocus(e) {
      this.focused = true;
      e.target.select();
    },
    onInput(e) {
      const el = e.target;
      const raw = el.value;
      const caret = el.selectionStart || 0;
      // karetdan oldingi raqamlar sonini eslab qolamiz
      const digitsBefore = raw.slice(0, caret).replace(/[^0-9]/g, '').length;

      const { display, num } = buildSumma(raw, this.precision);
      this.display = display;
      this.$emit('input', num);

      this.$nextTick(() => {
        const node = this.$refs.input;
        if (!node) return;
        node.value = display;
        // karetni o'sha raqamlar sonidan keyin joylash
        let pos = 0, count = 0;
        while (pos < display.length && count < digitsBefore) {
          if (/[0-9]/.test(display[pos])) count++;
          pos++;
        }
        try { node.setSelectionRange(pos, pos); } catch (err) { /* noop */ }
      });
    },
    onBlur(e) {
      this.focused = false;
      // yakuniy ko'rinishni tartibga solish
      this.display = this.toDisplay(this.value);
      this.$emit('blur', e);
    },
  },
};
</script>
